


























































import { Component, Vue } from 'vue-property-decorator'
import { Inject } from '../../domain/di/inject'
import { TYPES } from '../../types'
import { GetLocationsQry } from 'src/application/queries/get-locations-qry'
import { Location } from '../../domain/location/location'

@Component({ name: 'AppLocationList' })
export default class AppLocationList extends Vue {
  timeUpdater: number | undefined = undefined
  currentMinute: number | undefined = undefined
  private _locations: Location[] | undefined = undefined
  @Inject(TYPES.LOCATIONS_QUERY_GET)
  readonly getLocationsQry!: GetLocationsQry
  get locations() {
    this._locations = this.getLocationsQry.execute()
    return this._locations
  }
  sortByFeelsLike(){
    this._locations = this.getLocationsQry.execute()
    this._locations.sort((a, b) => (a?.weather?.feelsLike < b?.weather?.feelsLike) ? 1 : -1)
  }
  tapLocation(location: Location) {
    console.log(`location ${location.id} taped`)
    console.log(location)
  }
  timeInLocation(location: Location) {
    const timezone: number = Number(location.timezone) * 1000
    const utcTime: number = new Date().getTime()
    /* calculates the time in local location */
    const sum = new Date(timezone + utcTime)
    let hour = '' + new Date(sum).getUTCHours()
    let minute = '' + new Date(sum).getUTCMinutes()
    /* add 0 before hour and minute if needed */
    hour.length == 1 ? (hour = '0' + hour) : (hour = hour)
    minute.length == 1 ? (minute = '0' + minute) : (minute = minute)
    return `${hour}:${minute}`
  }
  flagImage(country: string) {
    return `https://www.countryflags.io/${country}/shiny/64.png`
  }
  capitalize(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1)
  }
  iconImage(icon: string) {
    return `https://openweathermap.org/img/w/${icon}.png`
  }
  created() {
    this.currentMinute = new Date().getMinutes()

    this.timeUpdater = setInterval(() => {
      const now = new Date().getMinutes()
      if (this.currentMinute == now) {
        return
      }
      this.currentMinute = now
      this.$forceUpdate()
    }, 1000)
  }
  destroy() {
    this.timeUpdater = undefined
  }
  titleColor(location:Location){
    /*
      --below-5-color: #9d59a9;
      --beetween-5-15-color: #518ca7;
      --beetween-15-25-color: #6c9838;
      --beetween-26-30-color: #bd6e56;
      --above-30-color: #ff3d00;
    */
    if(location.weather.feelsLike <= 4.99){
      return 'color: var(--below-5-color);'
    }
    if(location.weather.feelsLike >= 5 && location.weather.feelsLike <=14.99){
      return 'color: var(--beetween-5-15-color);'
    }
    
    if(location.weather.feelsLike >= 15 && location.weather.feelsLike <=24.99){
      return 'color: var(--beetween-15-25-color);'
    }
    if(location.weather.feelsLike >= 25 && location.weather.feelsLike <=29.99){
      return 'color: var(--beetween-26-30-color);'
    }
    if(location.weather.feelsLike >= 30){
      return 'color: var(--avobe-30-color);'
    }
  }
}
